import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import Home from './components/Home/Home';
import Portfolio from './components/Portfolio/Portfolio';
import Footer from './components/Footer/Footer';
import ThemeToggle from './components/ThemeToggle/ThemeToggle';
import World from './components/World/World';

const viewFromHash = () =>
  window.location.hash === '#portfolio' ? 'portfolio' : 'home';

function App() {
  const [{ theme, automatic }, setPreference] = useState(() => {
    try {
      const saved = localStorage.getItem('theme');
      if (saved === 'light' || saved === 'dark') return { theme: saved, automatic: false };
    } catch {
      // Storage can be unavailable in private or restricted browsing contexts.
    }
    return {
      theme: window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light',
      automatic: true,
    };
  });
  const [view, setView] = useState(viewFromHash);
  const siteRef = useRef(null);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  useEffect(() => {
    if (!automatic) return undefined;
    const mq = window.matchMedia?.('(prefers-color-scheme: dark)');
    const handler = (e) => setPreference({ theme: e.matches ? 'dark' : 'light', automatic: true });
    mq?.addEventListener('change', handler);
    return () => mq?.removeEventListener('change', handler);
  }, [automatic]);

  useEffect(() => {
    const onHashChange = () => {
      setView(viewFromHash());
    };
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  const toggleTheme = () => {
    const next = theme === 'light' ? 'dark' : 'light';
    setPreference({ theme: next, automatic: false });
    try {
      localStorage.setItem('theme', next);
    } catch {
      // Keep the selection for this visit when it cannot be persisted.
    }
  };

  const isHome = view === 'home';

  return (
    <>
      <div
        ref={siteRef}
        className="app portfolio-source"
        aria-hidden="true"
        inert=""
      >
        <ThemeToggle theme={theme} toggleTheme={toggleTheme} />
        <main className="main" data-view={view}>
          {isHome ? <Home /> : <Portfolio />}
          <Footer />
        </main>
      </div>
      <World siteRef={siteRef} />
    </>
  );
}

export default App;
